/**
 * Validate URL.
 *
 * @module validate.url
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @author Yaroslav Surilov <y.surilov@infomir.com>
 */

'use strict';

/**
 * Return whether the passed string is valid URL.
 *
 * @param {string} url - URL to validate
 *
 * @return {boolean} is given string valid URL
 */
module.exports = function ( url ) {
    // eslint-disable-next-line
    return new RegExp("^(((http|https|udp|rtp|rtsp|mms|mmsh|mmst|rtmp|igmp):\\/\\/)?@?(([a-zA-Z0-9а-яА-Я$\\-_.+!*'(),;:&=]|%[0-9a-fA-Fа-яА-Я]{2})+@)?(((25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])(\\.(25[0-5]|2[0-4][0-9]|[0-1][0-9][0-9]|[1-9][0-9]|[0-9])){3})|localhost|([a-zA-Zа-яА-Я0-9\\-\\u00C0-\\u017F]+\\.)+([a-zA-Zа-яА-Я]{2,}))(:[0-9]+)?|((file:\/\/\/|\/)[a-zA-Zа-яА-Я0-9\\-\\u00C0-\\u017F]+))(\\/(([a-zA-Zа-яА-Я0-9$\\-_.+!*'(),;:@&=\\s]|%[0-9a-fA-Fа-яА-Я]{2})*(\\/([a-zA-Zа-яА-Я0-9$\\-_.+!*'(),;:@&=\\s]|%[0-9a-fA-Fа-яА-Я]{2})*)*)?(\\?([a-zA-Zа-яА-Я0-9$\\-_.+!*'(),;:@&=\\/?]|%[0-9a-fA-Fа-яА-Я]{2})*)?(\\#([a-zA-Zа-яА-Я0-9$\\-_.+!*'(),;:@&=\\/?]|%[0-9a-fA-Fа-яА-Я]{2})*)?)?$").test(url);
};
